import {useState, type JSX} from 'react'
import * as Styled from './_styled/nav-bar-content.styled'
import {Icon} from '../../../media/Icon/index'
import {DropdownMenuStyle} from './_styled/location-expanded.styled'
import {NavBarLink} from './nav-bar-link'
import {useLocation} from 'react-router'
import {LocationExpandedButtonStyle} from './location-expanded-button/location-expanded-button.styled'
import useTypedSelector from '../../../../hooks/use-typed-selector'
import {isInternalUserSelector} from '../../../../store/state/current-user/selectors'
import {rolesSelector} from '../../../../store/state/roles/selectors'
import {isUserAllowed} from '../../../../values/Role'

export function SystemLink(): JSX.Element {
    const [systemDropDown, setSystemDropDown] = useState(false)
    const isInternalUser = useTypedSelector(isInternalUserSelector)
    const userRoles = useTypedSelector(rolesSelector)
    const isUserRoleAllowed = isUserAllowed(userRoles, ['DEVELOPER', 'THREAT_ANALYST'])
    const isAllowed = isInternalUser && isUserRoleAllowed

    const pathname = useLocation().pathname

    return (
        <Styled.DashboardLinkStyle
            onClick={() => {
                setSystemDropDown(!systemDropDown)
            }}
        >
            <Styled.NavigationLinkDiv
                id="navigation-system"
                activeLink={
                    pathname.startsWith('/policy-management') ||
                    pathname.startsWith('/vessel-management') ||
                    pathname.startsWith('/user-management') ||
                    pathname.startsWith('/engine-status') ||
                    pathname.startsWith('/self-monitoring-engine-status') ||
                    pathname.startsWith('/email-recipients') ||
                    pathname.startsWith('/swagger-links')
                }
            >
                System
                <LocationExpandedButtonStyle id="navigation-system-toggle">
                    <Icon
                        glyph={systemDropDown ? 'DropdownUp' : 'DropdownDown'}
                        height={15}
                        width={15}
                    />
                </LocationExpandedButtonStyle>
            </Styled.NavigationLinkDiv>
            {systemDropDown && (
                <DropdownMenuStyle>
                    {isUserAllowed(userRoles, [
                        'DEVELOPER',
                        'THREAT_ANALYST',
                        'CUSTOMER_ADMIN',
                    ]) && (
                        <NavBarLink
                            id="navigation-policy-management"
                            navLinkText="Policy Management"
                            path="/policy-management"
                        />
                    )}
                    {isUserAllowed(userRoles, [
                        'DEVELOPER',
                        'THREAT_ANALYST',
                        'CUSTOMER_ADMIN',
                    ]) && (
                        <NavBarLink
                            id="navigation-vessel-management"
                            navLinkText="Vessel Management"
                            path="/vessel-management"
                        />
                    )}
                    <NavBarLink
                        id="navigation-user-management"
                        navLinkText=" User Management"
                        path="/user-management"
                    />
                    {isAllowed && (
                        <NavBarLink
                            id="navigation-engine-status"
                            path="/engine-status"
                            navLinkText="Engine Status"
                        />
                    )}
                    {isAllowed && (
                        <NavBarLink
                            id="navigation-self-monitoring-engine-status"
                            path="/self-monitoring-engine-status"
                            navLinkText="Self-monitoring Engine Status"
                        />
                    )}
                    {isAllowed && (
                        <NavBarLink
                            id="navigation-email-recipients-management"
                            path="/email-recipients"
                            navLinkText="Email Recipient Management"
                        />
                    )}
                    {isAllowed && (
                        <NavBarLink
                            id="navigation-swagger-links"
                            path="/swagger-links"
                            navLinkText="Swagger Links"
                        />
                    )}
                </DropdownMenuStyle>
            )}
        </Styled.DashboardLinkStyle>
    )
}
